// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"248dcff5","59":"d3bf2b86","95":"55820d69","203":"162ab6bd","311":"636b92a9","353":"a4e41c9d","453":"e678203d","481":"62c76f6b","519":"64494a6c","524":"f6170c74","650":"1e1285fe","665":"4c6c56f1","690":"dd700390","811":"e0850750"}[chunkId] + ".chunk.js";
};